import { ReactElement, ReactNode } from 'react';
import { Button, Dropdown } from 'antd';
import { MoreVertical } from 'react-feather';

interface DefaultMoreVertDropdownProps {
  children?: ReactNode;
}

function DefaultMoreVertDropdown({
  children,
  ...rest
}: DefaultMoreVertDropdownProps) {
  return (
    <Dropdown overlay={children as ReactElement} {...rest} trigger={['click']}>
      <Button
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
        icon={<MoreVertical size="18" />}
        type="link"
      />
    </Dropdown>
  );
}

export default DefaultMoreVertDropdown;
